export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher50_tab.6572b73f.png";